import React, { useState, useMemo } from 'react';
import MaterialTable from 'material-table'
import { withStyles, Typography, IconButton, Tooltip } from '@material-ui/core';
import * as actions from './store/storageActions';
import * as action from '../../np-core/Auth/store/authActions';
import { connect } from 'react-redux';
import { Delete, Refresh } from '@material-ui/icons';
import { snackActions } from '../../sc-utilities/SnackBar';
import StorageDelete from './StorageDelete'
import { hasPermission, parseURL, localization, hasAtLeastOnePermission, getDimensionsOfPagination } from '../../sc-utilities';
import StorageDestroy from './StorageDestroy'
import Toolbar from '../../sc-utilities/Toolbar'
import { MuiTableRows } from '../../../themes';

const styles = theme => ({
    "@global": {
        "[class*='buttonsCustomer']": {
            margin: theme.spacing(),
            fontSize: '13px',
            width: '99.5%',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.buttonText.default
            },
        },
        "[class*='paletteButtons']": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.buttonText.default,
            margin: theme.spacing(),
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        }
    },
    fab: {
        textTransform: "none",
        width: '50%',
        color: theme.palette.buttonText.default,
        marginLeft: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    customToolbar: {
        marginTop: 15,
        marginLeft: 14,
        width: "900px"
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px'
    },
    toolbar: {
        paddingTop: '1%'
    }
});
let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const StorageList = props => {
    const { classes, translations, onBulkDeleteStorages, editable, saveColumnsFilter, onDestroyStorage, handleDestroy, destroyModalState, activeCustomer, permissions, tableColumns, onFetchStoragesCount, storages, onFetchStorages, tableRef} = props;
    let searchParams = parseURL(window.location.search);

    const [deleteModalState, setDeleteModalState] = useState({
        open: false,
        storageComponentIDs: [],
    })

    const tableActions = [
        {
            tooltip: translations["remove_all_selected_storage_components"] || "Remove All Selected storage ",
            icon: <Delete />,
            onClick: (rowData) => handleBulkDelete(rowData.map(component => component.ComponentID)),
            position: 'toolbarOnSelect',
        },
    ]

    const handleBulkDelete = storageComponentIDS => {
        if (!storageComponentIDS) {
            setDeleteModalState({ open: false, storageComponentIDs: [] });
            return;
        }
        setDeleteModalState({ open: true, storageComponentIDs: storageComponentIDS });
    };

    const fetching = storages.fetching;
    const columnObject = useMemo(() => tableColumns
        // eslint-disable-next-line react-hooks/exhaustive-deps
        , []); const [tableOptions, setTableOptions] = useState({
            filtering: true,
            sorting: false,
            selection: hasAtLeastOnePermission(permissions, ["component_delete"]),
            search: false,
            filterCellStyle: { maxWidth: '100px' },
            minBodyHeight: window.innerHeight - 300 < 250 ? 250 : window.innerHeight - 300,
            maxBodyHeight: window.innerHeight - 300,
            pageSizeOptions: rowsPageSizeInit,

            exportButton: false,
            rowStyle: (_rowData, index) => {
                return { backgroundColor: index % 2 ? MuiTableRows.odd : MuiTableRows.even };
            },
            columnsButton: true,
            pageSize: pageSize ? pageSize : 50,
            emptyRowsWhenPaging: false
        });

    const filterQuery = filters => {
        let obj = {};
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        obj['ComponentType'] = "storage";
        obj['ProductID'] = searchParams.productID;
        return obj;
    }
    async function fetchTableData(query) {
        let q = filterQuery(query.filters);

        query['ActiveCustomerID'] = activeCustomer;
        query['q'] = q;

        query['q']['WipeMethod'] = query.q.WipeMethod instanceof Array && query.q.WipeMethod.length > 0 ? query.q.WipeMethod : null;
        query['q']['WipeStatus'] = query.q.WipeStatus instanceof Array && query.q.WipeStatus.length > 0 ? query.q.WipeStatus : null;
        query['q']['VerificationStatus'] = query.q.VerificationStatus instanceof Array && query.q.VerificationStatus.length > 0 ? query.q.VerificationStatus : null;
        query['q']['Shredded'] = query.q.Shredded instanceof Array && query.q.Shredded.length > 0 ? query.q.Shredded : null;

        if (query['q'].SecurazeSolution && query['q'].SecurazeSolution.length===0) {
            query['q'].SecurazeSolution=null;
        }
        if (query['q'].WipeMethod && query['q'].WipeMethod.length===0) {
            query['q'].WipeMethod=null;
        }

        let count = await onFetchStoragesCount(query);
        if (!query['page'] && query['pageSize'] !== 20 && query['pageSize'] !== 100) {
            let dimensions = getDimensionsOfPagination(count)
            query['pageSize'] = dimensions.pageSize
            rowsPageSizeInit = dimensions.rowsPageSize
            pageSize = dimensions.pageSize
        }
        let result = count ? await onFetchStorages(query) : [];
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: result, page: query.page, pageSize: pageSize, totalCount: count };
    }

    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden
            return objColumns
        })
        objToSendColumn[`Storages`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomer })
        return newColumnState
    }

    const handleCloseDanger = async () => {
        await onBulkDeleteStorages({ ComponentIDs: deleteModalState.storageComponentIDs, ActiveCustomerID: activeCustomer });
        handleBulkDelete();
        tableRef.current && tableRef.current.onQueryChange()
    }

    const handleCloseDangerDestroy = async (data) => {
        let shredInformation = data;
        await onDestroyStorage({ ComponentID: destroyModalState.componentID, ActiveCustomerID: activeCustomer, ShreddedInfo: shredInformation });
        snackActions.snackBarComponent('Disk is shredded', 'info');
        handleDestroy();
        tableRef.current && tableRef.current.onQueryChange()
    }
    const tableTitle = () => {
        return <div className={classes.customToolbar}>
            <div className={classes.tableTitle}>
                <Typography className={classes.typography}> {translations["storages"] || "Storages"}</Typography>
                <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" disabled={fetching} onClick={() => tableRef.current && tableRef.current.onQueryChange()}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
            </div>
        </div>
    }


    return (<>
        <MaterialTable
            tableRef={tableRef}
            title={tableTitle()}
            columns={columnObject}
            data={fetchTableData}
            options={tableOptions}
            isLoading={fetching}
            localization={localization(translations)}
            onChangeRowsPerPage={(size) => {
                pageSize = size
            }}
            onChangeColumnHidden={columnHidden}
            actions={tableActions}
            components={{
                Toolbar: props => (
                    <Toolbar data={props} actions={tableActions} selectedRows={props.selectedRows} translations={translations} editable={!editable} classes={{ toolbar: classes.toolbar }} />
                )
            }}
            onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
        />
        {hasPermission(permissions, "component_delete") ? (
            <StorageDelete
                activeCustomer={activeCustomer}
                entityName={translations["storage"] || "Storage"}
                translations={translations}
                handleCloseDanger={handleCloseDanger}
                deleteModalState={deleteModalState}
                handleCloseSafe={() => handleBulkDelete()}
            />
        ) : null}
        {hasPermission(permissions, 'component_destroy') ? <StorageDestroy handleCloseDanger={handleCloseDangerDestroy} translations={translations} handleCloseSafe={() => handleDestroy()} destroyModalState={destroyModalState} /> : null}
    </>)
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchStoragesCount: filter => dispatch(actions.fetchStorageCount(filter)),
        onFetchStorages: filter => dispatch(actions.fetchStorage(filter)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
        onDestroyStorage: component => dispatch(actions.destroyStorage(component)),
        onBulkDeleteStorages: storage => dispatch(actions.bulkDeleteStorages(storage))
    };
};

const mapStateToProps = state => {
    return {
        permissions: state?.core?.login?.permissions || [],
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        storages: state.product.storages,
        translations: state.translate ? state.translate.translations.activeTranslations || {} : {}
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(StorageList));